import { ItemsContainerWebglSettingsConverter } from "./items-container-webgl-settings-converter";
import { ObjectCreator } from "../../../../../../web-graphics";

export class GridWebglSettingsConverter extends ItemsContainerWebglSettingsConverter {
  constructor(viewObjectConverters) {
    super(viewObjectConverters);
  }

  _copyColumn(columnSettings) {
    if (columnSettings === undefined) {
      return undefined;
    }
    let columnSettingsCopy = {
      width: columnSettings.width.copy()
    };
    ObjectCreator.addFields(columnSettings, columnSettingsCopy, ["width", "item"]);
    let convertedItemSettings = this._copyItem(columnSettings.item);
    if (convertedItemSettings !== undefined) {
      columnSettingsCopy.item = convertedItemSettings;
    }
    return columnSettingsCopy;
  }

  _copyRow(rowSettings) {
    if (!rowSettings) {
      return undefined;
    }
    let rowSettingsCopy = {
      columnsSpace: rowSettings.columnsSpace.copy(),
      height: rowSettings.height.copy(),
      columns: []
    };
    ObjectCreator.addFields(rowSettings, rowSettingsCopy, ["columnsSpace", "height", "columns"]);
    for (let columnIndex = 0; columnIndex < rowSettings.columns.length; columnIndex++) {
      let columnSettingsCopy = this._copyColumn(rowSettings.columns[columnIndex]);
      if (columnSettingsCopy !== undefined) {
        rowSettingsCopy.columns.push(columnSettingsCopy);
      }
    }
    return rowSettingsCopy;
  }

  convert(settings) {
    let settingsCopy = settings.copy();
    if (settings.rows === undefined || this.viewObjectConverters === undefined || this.viewObjectConverters.size == 0) {
      return settingsCopy;
    }
    settingsCopy.rows = [];
    for (let rowIndex = 0; rowIndex < settings.rows.length; rowIndex++) {
      let rowSettingsCopy = this._copyRow(settings.rows[rowIndex]);
      if (rowSettingsCopy !== undefined) {
        settingsCopy.rows.push(rowSettingsCopy);
      }
    }
    return settingsCopy;
  }
}
